import { useCallback, useState } from "react";

export interface CampaignTypeSelectionDialogController {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useCampaignTypeSelectionDialogController = (): CampaignTypeSelectionDialogController => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    open,
    close,
  };
};
